<template>
  <div>
    <div class="pa-4" v-if="canView">
      <Breadcrumbs
        :headline="headFee.title"
        :link="[
          { text: 'Tài chính', href: '/#' },
          { text: `${titleType.charAt(0).toUpperCase() + titleType.slice(1)}`, href: `/salary-head/${router}` },
          { text: `${headFee.title}`, disabled: true }
        ]"
      />
      <Info />
      <GroupHead />
      <div class="d-flex justify-center align-end mx-6">
        <v-btn
          v-if="canDelete"
          class="my-6 v-btn--outlined v-size--small error--text pa-4 font-weight-bold"
          depressed
          @click="removeHeadFee"
        >
          {{ `Xóa ${titleType}` }}
        </v-btn>
      </div>
    </div>
    <div v-else>
      <Page403 />
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'

import Breadcrumbs from '@/components/layout/Breadcrumbs'
import Page403 from '@/views/Page403.vue'
import Info from './head-detail/Info.vue'
import GroupHead from './head-detail/GroupHead.vue'
export default {
  components: {
    Breadcrumbs,
    Info,
    GroupHead,
    Page403
  },
  data() {
    return {
      dialog: false,
      createDialog: false
    }
  },
  async created() {
    this.$loading.active = true
    await this.reset()
    if (this.$route.params.id) {
      await this.fetchHead(this.$route.params.id)
      await this.fetchGroupHead(this.$route.params.id)
    }
    this.$loading.active = false
    this.setRouter(this.$route.params.category)
  },
  computed: {
    ...mapState('salaryHead', ['router', 'isSubFee', 'headFee']),
    titleType() {
      return this.$route.meta.title.replace('Chi tiết ', '')
    },
    pathName() {
      return this.$route.fullPath
    },
    canView() {
      return true
    },
    canDelete() {
      if (this.headFee.isDefault) return false
      return true
    },
    canCreateApply() {
      return true
    }
  },
  methods: {
    ...mapActions('salaryHead', ['fetchHead', 'fetchGroupHead', 'deleteHead', 'setRouter', 'reset']),
    async removeHeadFee() {
      this.$dialog.confirm({
        title: `Xác nhận xóa ${this.titleType}?`,
        text: `<div>Thao tác này sẽ không thể hoàn tác.<br/> Bạn có chắc chắn muốn xoá ${this.titleType}?</div>`,
        okText: 'Xóa',
        cancelText: 'Hủy',
        type: 'delete',
        done: async () => {
          try {
            this.$loading.active = true
            await this.deleteHead({ id: this.headFee.id, type: this.router })
            this.$alert.deleteSuccess(this.titleType)
            this.$router.push({ path: `/salary-head/${this.router}` })
            this.$loading.active = false
          } catch (e) {
            this.$alert.deleteError({
              title: 'Lỗi thao tác',
              description: `Không thể xóa ${this.titleType}. Vui lòng thử lại`
            })
          }
        }
      })
    }
  },
  watch: {
    pathName() {
      this.setRouter(this.$route.params.category)
    }
  }
}
</script>
